import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Cron } from 'react-js-cron';
import 'react-js-cron/dist/styles.css';
import { fr } from './locales';

const CronTaskFrequencyField = ({ name, optional, onChange }) => {
    const { i18n } = useTranslation();

    const locale = React.useMemo(() => {
        return i18n.language === 'fr' ?  fr : undefined;
    }, [i18n.language]);

    const renderField = field => (
        <div className="d-flex gap-2">
            <div>
                <input
                    type="text"
                    value={field.input.value}
                    onChange={(e: any) => { field.input.onChange(e.target.value); }}
                    className="form-control"
                    placeholder="* * * * *"
                />
            </div>
            {field.input.value && (
                <>
                    <span className="">
                        <i className="fa fa-swap" />
                    </span>
                    <div className="text-sm -mb-[10px]">
                        <Cron
                            defaultPeriod="month"
                            value={field.input.value}
                            setValue={(v: any) => { field.input.onChange(v); }}
                            locale={locale}
                            clearButtonAction="empty"
                            leadingZero
                        />
                    </div>
                </>
            )}
        </div>
    );

    return (
        <div className="CronTaskFrequencyField">
            <Field
                required={ !optional }
                component={ renderField }
                className="form-control"
                type="text"
                name={ name }
                id={ name }
                onChange={ onChange }
            />
        </div>
    );
}

export default CronTaskFrequencyField;
